import { Component, OnInit, inject, model, viewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { BaseComponent, BaseEditFormModalComponent } from 'tms-lib';
import { AddressAddressee, AddressAddresseeService, AddressService, TmsFormlyService } from 'tms-web-shared';

@Component({
  selector: 'app-address-create-addressees-modal',
  templateUrl: './address-create-addressees-modal.component.html',
  styleUrl: './address-create-addressees-modal.component.scss',
  imports: [BaseEditFormModalComponent],
})
export class AddressCreateAddresseesModalComponent extends BaseComponent implements OnInit {
  protected readonly addressAddresseeService = inject(AddressAddresseeService);
  private readonly addressService = inject(AddressService);
  private readonly formlyService = inject(TmsFormlyService);

  private readonly form = viewChild(BaseEditFormModalComponent);
  public readonly id = model<string>();
  public readonly addressId = model<string>();

  public newAddressee: AddressAddressee;

  protected fields: FormlyFieldConfig[];

  ngOnInit() {
    this.getFields();
  }

  private getFields() {
    this.fields = [
      this.formlyService.text('addressee', $localize`Addressee`, { required: true }),
      this.formlyService.text('telephone', $localize`Telephone`, { maxLength: 30 }),
      this.formlyService.text('email', $localize`Email`, { maxLength: 255 }),
    ];
  }

  saved(model: AddressAddressee) {
    this.newAddressee = model;
    this.addressService.refreshDetails.next();
  }
}
